import { useEffect } from "react";

// A bar fixed to the bottom of the screen sits over whatever scrolls under it.
// Keyboard focus is scrolled into view without knowing the bar is there, so a
// focused link can end up entirely behind it (WCAG 2.4.11), and the last links
// on the page (the footer) can never scroll out from under it at all.
// While the bar is mounted, pad the page by the bar's height and tell the
// browser to keep that much room when it scrolls something into view.
export default function useBottomBarClearance(ref, active = true) {
  useEffect(() => {
    const bar = ref.current;
    if (!active || !bar) return undefined;
    const html = document.documentElement;
    const body = document.body;
    const prev = { pad: body.style.paddingBottom, scroll: html.style.scrollPaddingBottom };
    const apply = () => {
      const h = `${Math.ceil(bar.getBoundingClientRect().height)}px`;
      body.style.paddingBottom = h;
      html.style.scrollPaddingBottom = h;
    };
    apply();
    const ro = typeof ResizeObserver === "function" ? new ResizeObserver(apply) : null;
    ro?.observe(bar);
    return () => {
      ro?.disconnect();
      body.style.paddingBottom = prev.pad;
      html.style.scrollPaddingBottom = prev.scroll;
    };
  }, [ref, active]);
}
